export const getMonthMatrix = (monthDate) => {
    const year = monthDate.getFullYear();
    const month = monthDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const start = new Date(firstDay);
    start.setDate(start.getDate() - firstDay.getDay());

    const end = new Date(lastDay);
    end.setDate(end.getDate() + (6 - lastDay.getDay()));

    const matrix = [];
    const day = new Date(start);
    while (day <= end) {
        const week = Array.from({ length: 7 }, () => {
            const d = new Date(day);
            day.setDate(day.getDate() + 1);
            return d.getMonth() === month ? d : null;
        });
        matrix.push(week);
    }
    return matrix;
};

export const addMonths = (date, count) => {
    const d = new Date(date);
    d.setMonth(d.getMonth() + count);
    return d;
};

export const formatDateKey = (date) => {
    return date.toISOString().split('T')[0]; // "YYYY-MM-DD"
};

export const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

export const isInRange = (date, start, end) =>
    date >= start && date <= end;
